import { z } from "zod";

export const imessagePhoneNumberSchema = z.string().regex(/^\+[1-9]\d{6,14}$/u);

export const imessageAddressSchema = z.union([
    imessagePhoneNumberSchema,
    z.email(),
]);
